import styled, { css } from 'styled-components/macro';

import { hexToRGB } from '@repo-level/core-front';

interface IScPaymentMethodProps {
  isCryptoMethod: boolean;
}

export const ScPaymentMethod = styled.div<IScPaymentMethodProps>`
  border-radius: 12px;
  height: fit-content;
  color: ${({ theme }) => theme.whiteColor};

  .title-wrapper {
    display: grid;
    grid-template-columns: 1fr auto;
    margin-bottom: 16px;
    font-size: 16px;
    font-weight: 700;
    line-height: 28px;
    letter-spacing: 0.16px;
    color: ${({ theme }) => theme.whiteColor};
  }

  ${({ isCryptoMethod }) =>
    isCryptoMethod &&
    css`
      .amount-wrapper {
        margin-top: 8px;
      }
    `}

  .instantly-text {
    text-transform: capitalize;
    padding-right: 5px;
  }

  .amount-value {
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0px;
    font-weight: 400;
    color: ${({ theme }) => theme.grayColor1};
    @media (min-width: 360px) and (max-width: 405px) {
      display: flex;
      flex-direction: column;
      align-items: end;
    }
  }

  h2 {
    text-transform: capitalize;
    font-size: 16px;
    font-weight: 700;
    line-height: 28px;
    letter-spacing: 0.16px;
    white-space: nowrap;
  }

  .profiles {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    margin: 24px 0;
    gap: 8px;

    .profile {
      cursor: pointer;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      background-color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.2)};
      padding: 12px 8px;
      border-radius: 12px;
      border: 2px solid ${({ theme }) => hexToRGB(theme.whiteColor, 0.3)};

      text-align: center;

      font-size: 14px;
      font-weight: 700;
      line-height: 20px;

      &.active {
        border: 2px solid ${({ theme }) => theme.greenColor};
      }
    }
  }

  .permission {
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 24px;
  }

  .warn_ico {
    margin-bottom: -5px;
    margin-right: 5px;
  }

  p {
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0px;
  }

  .remove-btn {
    margin: 16px auto 0;
    width: fit-content;

    cursor: pointer;
    color: ${({ theme }) => theme.grayColor1};
    text-align: center;
    font-size: 12px;
    line-height: 130%;
    text-decoration-line: underline;
  }
`;
